<div class="item-grid-container">
  <div class="retailer-details-grid search-holder">
    <ul class="list-inline grid-top-actions mb-3">
      <li class="list-inline-item ">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInput
          class="
            rounded-pill
            px-3
            py-2
            mb-0
            border-0
            bg-light
            w-100
            me-0
            input-search
            ms-3
          "
          (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>

      <li  class="list-inline-item float-end">
        <button [disabled]="isButtonDisabled" mat-stroked-button class="bg-theme" (click)="exportData()">
          <span translate class="translate">pages.newRetailer.download</span>
          <i class="mi mi-save-alt"></i>
        </button>
      </li>
      <li *ngIf="!isButtonDisabled"  class="list-inline-item float-end mx-2">
        <button
          mat-stroked-button
          [disabled]="!showUpdateRetailer"
          class="bg-theme"
          [routerLink]="['../manageretailer', retailerId]"
          routerLinkActive="router-link-active"
        >
          {{ "pages.newRetailer.edit" | translate }}
          <i class="mi mi-drive-file-rename-outline"></i>
        </button>
      </li>
    </ul>

    <ag-grid-angular
      style="width: 100%; height: 65vh; max-height: 70vh"
      class="ag-theme-material"
      [rowHeight]="40"
      [enableFilter]="true"
      [enableSorting]="true"
      [enableColResize]="true"
      [rowSelection]="rowSelection"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    >
    </ag-grid-angular>
  </div>
</div>
